import { render, staticRenderFns } from "./Suppliers.vue?vue&type=template&id=526ffd4e&scoped=true&"
import script from "./Suppliers.vue?vue&type=script&lang=js&"
export * from "./Suppliers.vue?vue&type=script&lang=js&"
import style0 from "./Suppliers.vue?vue&type=style&index=0&id=526ffd4e&scoped=true&lang=css&"
import style1 from "./Suppliers.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526ffd4e",
  null
  
)

export default component.exports